const reloadCurrentPage = () => {
    globalThis.location.reload();
};

export default reloadCurrentPage;
